const FAVICON_BASE_URL = 'https://www.google.com/s2/favicons';
const FAVICON_REQUEST_SIZE_PX = 64;

function extractHost(url: string): string | null {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return null;
  }
}

// Display label for a source row; falls back to the raw string when the
// url can't be parsed so the user still sees something.
export function getSourceHostLabel(url: string): string {
  const host = extractHost(url);
  return host ? `${host}/` : url;
}

export function getFaviconUrl(url: string): string | null {
  const host = extractHost(url);
  if (!host) return null;
  return `${FAVICON_BASE_URL}?domain=${encodeURIComponent(
    host
  )}&sz=${FAVICON_REQUEST_SIZE_PX}`;
}
